import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

const NotFound = () => {
  return (
    <div className="min-h-screen pt-20 flex items-center justify-center bg-slate-950" data-testid="not-found-page">
      <Seo title="Page Not Found | YTEK Controls" description="The page you are looking for does not exist." noindex />
      <div className="text-center px-6">
        <p className="font-mono text-ocean-500 text-lg mb-4">404</p>
        <h1 className="font-heading font-light text-4xl md:text-6xl tracking-tighter text-white mb-6">
          Page not found
        </h1>
        <p className="text-slate-400 mb-8 max-w-md mx-auto">
          The page you are looking for doesn&apos;t exist or has been moved.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <Link
            to="/"
            className="px-6 py-3 bg-ocean-500 text-white hover:bg-ocean-400 transition-colors"
            data-testid="not-found-home-link"
          >
            Back to Home
          </Link>
          <Link
            to="/contact"
            className="px-6 py-3 border border-white/20 text-white hover:border-ocean-500 transition-colors"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
